var Bash = "Bash";
var C = "C";
var Go = "Go";
var Java = "Java";
var JavaScript = "JavaScript";
var Kotlin = "Kotlin";
var Perl = "Perl";
var PHP = "PHP";
var PowerShell = "PowerShell";
var Python = "Python";
var Ruby = "Ruby";
var Rust = "Rust";
var SQL = "SQL";
var Swift = "Swift";
var TypeScript = "TypeScript";
var Analytics = "Analiz";
var Blockchain = "Blok zinciri";
var Compliance = "Uygunluk";
var Compute = "İşlem";
var Containers = "Container'lar";
var Databases = "Veritabanları";
var Games = "Oyunlar";
var Migration = "Geçiş";
var Mobile = "Mobil";
var Networking = "Ağ";
var Robotics = "Robotik";
var Satellite = "Uydu";
var Security = "Güvenlik";
var Serverless = "Sunucusuz";
var Storage = "Depolama";
var WebApps = "Web Uygulamaları";
var Alexa = "Alexa";
var Apache = "Apache";
var App2Container = "App2Container";
var AppFabric = "AppFabric";
var AppFlow = "AppFlow";
var AppSync = "AppSync";
var Artifact = "Artifact";
var Athena = "Athena";
var Aurora = "Aurora";
var Backup = "Backup";
var Batch = "Batch";
var Bedrock = "Bedrock";
var Braket = "Braket";
var Budgets = "Budgets";
var Chatbot = "Chatbot";
var Chime = "Chime";
var Cloud9 = "Cloud9";
var CloudEndure = "CloudEndure";
var CloudFormation = "CloudFormation";
var CloudFront = "CloudFront";
var CloudHSM = "CloudHSM";
var CloudSearch = "CloudSearch";
var CloudShell = "CloudShell";
var CloudTrail = "CloudTrail";
var CloudWatch = "CloudWatch";
var CodeArtifact = "CodeArtifact";
var CodeBuild = "CodeBuild";
var CodeCatalyst = "CodeCatalyst";
var CodeCommit = "CodeCommit";
var CodeDeploy = "CodeDeploy";
var CodeGuru = "CodeGuru";
var CodePipeline = "CodePipeline";
var CodeStar = "CodeStar";
var Cognito = "Cognito";
var Comprehend = "Comprehend";
var Config = "Yapılandırma";
var Connect = "Bağlanın";
var Copilot = "Copilot";
var Corretto = "Corretto";
var Dash = "Dash";
var DataSync = "DataSync";
var DataZone = "DataZone";
var DeepComposer = "DeepComposer";
var DeepLens = "DeepLens";
var DeepRacer = "DeepRacer";
var Detective = "Tespit Edici";
var DocumentDB = "DocumentDB";
var DynamoDB = "DynamoDB";
var EMR = "EMR";
var EventBridge = "EventBridge";
var Fargate = "Fargate";
var FinSpace = "FinSpace";
var Forecast = "Forecast";
var FreeRTOS = "FreeRTOS";
var FSx = "FSx";
var GameKit = "GameKit";
var GameLift = "GameLift";
var GameSparks = "GameSparks";
var Glue = "Glue";
var GuardDuty = "GuardDuty";
var Health = "Health";
var HealthLake = "HealthLake";
var Inferentia = "Inferentia";
var Inspector = "Inspector";
var Kendra = "Kendra";
var Kinesis = "Kinesis";
var Lambda = "Lambda";
var Lex = "Lex";
var Lightsail = "Lightsail";
var Lookout = "Lookout";
var Lumberyard = "Lumberyard";
var Macie = "Macie";
var Monitron = "Monitron";
var Neptune = "Neptune";
var Neuron = "Neuron";
var One = "Bir";
var OpenShift = "OpenShift";
var OpsWorks = "OpsWorks";
var Organizations = "Organizations";
var Outposts = "Outposts";
var Panorama = "Panorama";
var Personalize = "Personalize";
var Pinpoint = "Pinpoint";
var Polly = "Polly";
var PrivateLink = "PrivateLink";
var Prometheus = "Prometheus";
var Proton = "Proton";
var QuickSight = "QuickSight";
var Redshift = "Redshift";
var Rekognition = "Rekognition";
var RoboMaker = "RoboMaker";
var SageMaker = "SageMaker";
var Shield = "Shield";
var Snowball = "Snowball";
var Snowcone = "Snowcone";
var Snowmobile = "Snowmobile";
var Sumerian = "Sumerian";
var TensorFlow = "TensorFlow";
var Textract = "Textract";
var Thinkbox = "Thinkbox";
var Timestream = "Timestream";
var Titan = "Titan";
var Transcribe = "Transcribe";
var Translate = "Translate";
var VMware = "VMWare";
var Wavelength = "Wavelength";
var Wickr = "Wickr";
var WorkDocs = "WorkDocs";
var WorkLink = "WorkLink";
var WorkMail = "WorkMail";
var WorkSpaces = "WorkSpaces";
var interests = {
	".NET": ".NET",
	Bash: Bash,
	C: C,
	"C#": "C#",
	"C++": "C++",
	Go: Go,
	Java: Java,
	JavaScript: JavaScript,
	Kotlin: Kotlin,
	Perl: Perl,
	PHP: PHP,
	PowerShell: PowerShell,
	Python: Python,
	Ruby: Ruby,
	Rust: Rust,
	"SAP ABAP": "SAP ABAP",
	SQL: SQL,
	Swift: Swift,
	TypeScript: TypeScript,
	Analytics: Analytics,
	"Application Integration": "Uygulama Entegrasyonu",
	"AR/VR": "AR/VR",
	"Architecture Strategy": "Mimarlık Stratejisi",
	"Artificial Intelligence": "Yapay Zeka",
	Blockchain: Blockchain,
	"Business applications": "İş Uygulamaları",
	"Cloud Financial Management": "Bulut Finansal Yönetimi",
	"Cloud Foundations": "Bulut Temelleri",
	Compliance: Compliance,
	Compute: Compute,
	"Contact Center": "İrtibat Merkezi",
	Containers: Containers,
	"Data Integration": "Veri Entegrasyonu",
	Databases: Databases,
	"Developer Tools": "Geliştirici Araçları",
	"End-User Computing (EUC)": "Son Kullanıcı Bilgi İşlemi (EUC)",
	"Front-End Development": "Ön Uç Geliştirme",
	Games: Games,
	"Generative AI": "Üretici yapay zeka",
	"High Performance Computing (HPC)": "Yüksek Performanslı Bilgi İşlem (HPC)",
	"Identity Management": "Kimlik Yönetimi",
	"Machine Learning": "Makine Öğrenimi",
	"Machine Learning & AI": "Makine Öğrenimi ve Yapay Zeka",
	"Management & Governance": "Yönetim ve Yönetişim",
	"Media services": "Medya Hizmetleri",
	Migration: Migration,
	Mobile: Mobile,
	Networking: Networking,
	"Networking & Content Delivery": "Ağ Oluşturma ve İçerik Teslimi",
	"Quantum Technologies": "Kuantum teknolojileri",
	Robotics: Robotics,
	Satellite: Satellite,
	Security: Security,
	"Security, Identity, & Compliance": "Güvenlik, Kimlik ve Uygunluk",
	Serverless: Serverless,
	Storage: Storage,
	WebApps: WebApps,
	"API Gateway": "API Gateway",
	Alexa: Alexa,
	Apache: Apache,
	"Apache Airflow": "Apache Airflow",
	"Apache Kafka": "Apache Kafka",
	"APP Config": "APP Config",
	"App Mesh": "App Mesh",
	"App Runner": "App Runner",
	"App Studio": "Uygulama Stüdyosu",
	App2Container: App2Container,
	AppFabric: AppFabric,
	AppFlow: AppFlow,
	"Application Discovery Service": "Uygulama Keşif Hizmeti",
	"Application Migration Service": "Uygulama Taşıma Hizmeti",
	"AppStream 2.0": "AppStream 2.0",
	AppSync: AppSync,
	Artifact: Artifact,
	Athena: Athena,
	"Audit Manager": "Denetim Yöneticisi",
	Aurora: Aurora,
	"Auto Scaling": "Otomatik Ölçeklendirme",
	Backup: Backup,
	Batch: Batch,
	Bedrock: Bedrock,
	"Billing Conductor": "Faturalama Yöneticisi",
	Braket: Braket,
	Budgets: Budgets,
	"Certificate Manager": "Sertifika Yöneticisi",
	Chatbot: Chatbot,
	Chime: Chime,
	"Clean Rooms": "Clean Rooms",
	"Cloud Control API": "Cloud Control API",
	"Cloud Development Kit (CDK)": "Bulut Geliştirme Seti (CDK)",
	"Cloud Directory": "Bulut Dizini",
	"Cloud Map": "Cloud Map",
	"Cloud WAN": "Bulut WAN",
	Cloud9: Cloud9,
	CloudEndure: CloudEndure,
	CloudFormation: CloudFormation,
	CloudFront: CloudFront,
	CloudHSM: CloudHSM,
	CloudSearch: CloudSearch,
	CloudShell: CloudShell,
	CloudTrail: CloudTrail,
	CloudWatch: CloudWatch,
	CodeArtifact: CodeArtifact,
	CodeBuild: CodeBuild,
	CodeCatalyst: CodeCatalyst,
	CodeCommit: CodeCommit,
	CodeDeploy: CodeDeploy,
	CodeGuru: CodeGuru,
	CodePipeline: CodePipeline,
	CodeStar: CodeStar,
	Cognito: Cognito,
	Comprehend: Comprehend,
	"Compute Optimizer": "AWS İşlem Optimizasyon Aracı",
	Config: Config,
	Connect: Connect,
	"Control Tower": "Control Tower",
	Copilot: Copilot,
	Corretto: Corretto,
	"Cost Explorer": "Maliyet Gezgini",
	Dash: Dash,
	"Data Exchange": "Veri Değişimi",
	"Data Pipeline": "AWS Veri İşlem Hattı",
	"Database Migration Service (DMS)": "Veri Tabanı Taşıma Hizmeti (DMS)",
	DataSync: DataSync,
	DataZone: DataZone,
	"Deadline Cloud": "Deadline Cloud",
	"Deep Learning": "Derin Öğrenme",
	DeepComposer: DeepComposer,
	DeepLens: DeepLens,
	DeepRacer: DeepRacer,
	Detective: Detective,
	"Device Farm": "Device Farm",
	"DevOps Guru": "DevOps Guru",
	" Direct Connect": " Direct Connect",
	"Directory Service": "Dizin Hizmeti",
	"Distro for OpenTelemetry": "OpenTelemetry İçin Distro",
	DocumentDB: DocumentDB,
	DynamoDB: DynamoDB,
	"Elastic Beanstalk": "Elastic Beanstalk",
	"Elastic Block Storage (EBS)": "Esnek Blok Depolama (EBS)",
	"Elastic Cloud Compute (EC2)": "Elastic Cloud Compute (EC2)",
	"Elastic Container Registry (ECR)": "Esnek Container Kayıt Defteri (ECR)",
	"Elastic Container Service (ECS)": "Elastic Container Service (ECS)",
	"Elastic Disaster Recovery (DRS)": "Esnek Olağanüstü Durum Kurtarma (DRS)",
	"Elastic File System (EFS)": "Esnek Dosya Sistemi (EFS)",
	"Elastic Inference": "Esnek Çıkarım",
	"Elastic Kubernetes Service (EKS)": "Esnek Kubernetes Hizmeti (EKS)",
	"Elastic Transcoder": "Elastic Transcoder",
	"Elemental ": "Elemental ",
	EMR: EMR,
	EventBridge: EventBridge,
	Fargate: Fargate,
	"Fault Injection Simulator": "Hata Ekleme Simülatörü",
	"File Cache": "File Cache",
	FinSpace: FinSpace,
	"Firewall Manager": "AWS Güvenlik Duvarı",
	Forecast: Forecast,
	"Fraud Detector": "Dolandırıcılık Algılayıcı",
	FreeRTOS: FreeRTOS,
	FSx: FSx,
	GameKit: GameKit,
	GameLift: GameLift,
	GameSparks: GameSparks,
	"Global Accelerator": "Küresel Hızlandırıcı",
	Glue: Glue,
	"Ground Station": "Yer İstasyonu",
	GuardDuty: GuardDuty,
	Health: Health,
	HealthLake: HealthLake,
	"IAM Identity Center": "IAM Kimlik Merkezi",
	"Identity and Access Management (IAM)": "Kimlik ve Erişim Yönetimi (IAM)",
	Inferentia: Inferentia,
	Inspector: Inspector,
	"Interactive Video Service": "Etkileşimli Video Hizmeti",
	"Internet of Things (IoT)": "Nesnelerin İnterneti (IoT)",
	Kendra: Kendra,
	"Key Management Service (KMS)": "Anahtar Yönetimi Hizmeti (KMS)",
	Kinesis: Kinesis,
	"Lake Formation": "Lake Formation",
	Lambda: Lambda,
	"Launch Wizard": "Başlatma Sihirbazı",
	Lex: Lex,
	"License Manager": "License Manager",
	Lightsail: Lightsail,
	"Local Zones": "Yerel Alanlar",
	"Location Service": "Location Service",
	Lookout: Lookout,
	Lumberyard: Lumberyard,
	Macie: Macie,
	"Mainframe Modernization": "Ana Bilgisayar Modernizasyonu",
	"Managed Blockchain": "Yönetilen Blok Zinciri",
	"Managed Grafana": "Yönetilen Grafana",
	Monitron: Monitron,
	"MQ Message Broker": "MQ Mesaj Aracısı",
	Neptune: Neptune,
	"Network Firewall": "Ağ Güvenlik Duvarı",
	Neuron: Neuron,
	"Nimble Studio": "Nimble Stüdyosu",
	One: One,
	"OpenSearch Service (OSS)": "OpenSearch Hizmeti (OSS)",
	OpenShift: OpenShift,
	OpsWorks: OpsWorks,
	Organizations: Organizations,
	Outposts: Outposts,
	Panorama: Panorama,
	Personalize: Personalize,
	Pinpoint: Pinpoint,
	Polly: Polly,
	"Private 5G": "Özel 5G",
	"Private Certificate Authority": "Özel Sertifika Yetkilisi",
	PrivateLink: PrivateLink,
	Prometheus: Prometheus,
	Proton: Proton,
	"Q ": "Q ",
	"Quantum Solutions Lab": "Quantum Çözüm Laboratuvarı",
	QuickSight: QuickSight,
	"Relational Database Service (RDS)": "Relational Database Service (RDS)",
	Redshift: Redshift,
	Rekognition: Rekognition,
	"rePost Private": "rePost Özel",
	"Resilience Hub": "Dayanıklılık Merkezi",
	"Resource Access Manager": "Resource Access Manager",
	RoboMaker: RoboMaker,
	"Route 53": "Route 53",
	SageMaker: SageMaker,
	"Secrets Manager": "Gizli Bilgi Yöneticisi",
	"Security Hub": "Güvenlik Merkezi",
	"Security Lake": "Security Lake",
	"Server Migration Service (SMS)": "Sunucu Taşıma Hizmeti (SMS)",
	"Serverless Application Repository": "Sunucusuz Uygulama Deposu",
	"Service Catalog": "Service Catalog",
	"Service Management Connector": "Hizmet Yönetimi Bağlayıcısı",
	Shield: Shield,
	"Simple Email Service (SES)": "Simple Email Service (SES)",
	"Simple Notification Service (SNS)": "Simple Notification Service (SNS)",
	"Simple Queue Service (SQS)": "Basit Kuyruk Hizmeti (SQS)",
	"Simple Storage Service (S3)": "Simple Storage Service (S3)",
	"Simspace Weaver": "Simspace Weaver",
	"Single Sign-On (SSO)": "Tek Oturum Açma (SSO)",
	"Snow Family": "Snow Ailesi",
	Snowball: Snowball,
	Snowcone: Snowcone,
	Snowmobile: Snowmobile,
	"Step Functions": "Adım İşlevleri",
	"Storage Gateway": "Storage Gateway",
	Sumerian: Sumerian,
	"Supply Chain": "Tedarik Zinciri",
	"Systems Manager": "Sistem Yöneticisi",
	"Telco Network Builder": "Telekomünikasyon Ağı Oluşturucusu",
	TensorFlow: TensorFlow,
	Textract: Textract,
	Thinkbox: Thinkbox,
	Timestream: Timestream,
	Titan: Titan,
	Transcribe: Transcribe,
	Translate: Translate,
	"Trusted Advisor": "Trusted Advisor",
	"Verified Access": "Doğrulanmış Erişim",
	"Verified Permissions": "Doğrulanmış İzinler",
	"Virtual Private Cloud (VPC)": "Sanal Özel Bulut (VPC)",
	"Virtual Private Network (VPN)": "Sanal Özel Ağ (VPN)",
	VMware: VMware,
	Wavelength: Wavelength,
	"Web Application Firewall (WAF)": "Web Uygulaması Güvenlik Duvarı (WAF)",
	Wickr: Wickr,
	WorkDocs: WorkDocs,
	WorkLink: WorkLink,
	WorkMail: WorkMail,
	WorkSpaces: WorkSpaces,
	"X-Ray": "X-Ray"
};

export { Alexa, Analytics, Apache, App2Container, AppFabric, AppFlow, AppSync, Artifact, Athena, Aurora, Backup, Bash, Batch, Bedrock, Blockchain, Braket, Budgets, C, Chatbot, Chime, Cloud9, CloudEndure, CloudFormation, CloudFront, CloudHSM, CloudSearch, CloudShell, CloudTrail, CloudWatch, CodeArtifact, CodeBuild, CodeCatalyst, CodeCommit, CodeDeploy, CodeGuru, CodePipeline, CodeStar, Cognito, Compliance, Comprehend, Compute, Config, Connect, Containers, Copilot, Corretto, Dash, DataSync, DataZone, Databases, DeepComposer, DeepLens, DeepRacer, Detective, DocumentDB, DynamoDB, EMR, EventBridge, FSx, Fargate, FinSpace, Forecast, FreeRTOS, GameKit, GameLift, GameSparks, Games, Glue, Go, GuardDuty, Health, HealthLake, Inferentia, Inspector, Java, JavaScript, Kendra, Kinesis, Kotlin, Lambda, Lex, Lightsail, Lookout, Lumberyard, Macie, Migration, Mobile, Monitron, Neptune, Networking, Neuron, One, OpenShift, OpsWorks, Organizations, Outposts, PHP, Panorama, Perl, Personalize, Pinpoint, Polly, PowerShell, PrivateLink, Prometheus, Proton, Python, QuickSight, Redshift, Rekognition, RoboMaker, Robotics, Ruby, Rust, SQL, SageMaker, Satellite, Security, Serverless, Shield, Snowball, Snowcone, Snowmobile, Storage, Sumerian, Swift, TensorFlow, Textract, Thinkbox, Timestream, Titan, Transcribe, Translate, TypeScript, VMware, Wavelength, WebApps, Wickr, WorkDocs, WorkLink, WorkMail, WorkSpaces, interests as default };
